import { showDialog } from "../../../actions/notifications";
import ActionDropdown from "../../../controls/ActionDropdown";
import Icon from "../../../controls/Icon";
import IconBar from "../../../controls/IconBar";
import { IconButton } from "../../../controls/TooltipControls";
import { ComponentEx, connect, translate } from "../../../controls/ComponentEx";
import { showError } from "../../../util/message";
import { activeGameId } from "../../../util/selectors";
import { removeCategory, renameCategory, setCategory, setCategoryOrder, } from "../actions/category";
import createTreeDataObject from "../util/createTreeDataObject";
import * as React from "react";
import { FormControl } from "react-bootstrap";
import SortableTree from "react-sortable-tree";
import { unknownToError } from "@vortex/shared";
const nop = () => undefined;
/**
 * displays the list of categories related for the current game.
 *
 */
class CategoryList extends ComponentEx {
    mButtons;
    constructor(props) {
        super(props);
        this.initState({
            treeData: [],
            expandedTreeData: [],
            expanded: [],
            showEmpty: true,
            searchString: "",
            searchFocusIndex: 0,
            searchFoundCount: 0,
        });
        const { t } = props;
        this.mButtons = [
            {
                title: "Expand All",
                icon: "expand-all",
                action: this.expandAll,
            },
            {
                title: "Collapse All",
                icon: "collapse-all",
                action: this.collapseAll,
            },
            {
                title: "Add Root",
                icon: "folder-add",
                action: this.addRootCategory,
            },
            {
                title: "Show/Hide Empty",
                icon: "hide",
                action: this.toggleShowEmpty,
            },
            {
                title: "Sort Alphabetically",
                icon: "loot-sort",
                action: this.sortAlphabetically,
            },
        ];
    }
    componentDidMount() {
        this.refreshTree(this.props);
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        if (this.props.categories !== newProps.categories) {
            this.refreshTree(newProps);
        }
    }
    render() {
        const { t } = this.props;
        const { expandedTreeData, searchString, searchFocusIndex, searchFoundCount, } = this.state;
        return (React.createElement("div", { className: "categories-dialog" },
            React.createElement(IconBar, { group: "categories-icons", staticElements: this.mButtons, className: "menubar categories-icons", t: t }),
            React.createElement("div", { className: "search-category-box" },
                React.createElement("div", { style: { display: "inline-block", position: "relative" } },
                    React.createElement(FormControl, { id: "search-category-input", type: "text", placeholder: t("Search"), value: searchString || "", onChange: this.startSearch }),
                    React.createElement(Icon, { className: "search-icon", name: "search" }),
                    React.createElement("span", { className: "search-position" }, t("{{ pos }} of {{ total }}", {
                        replace: {
                            pos: searchFoundCount > 0 ? searchFocusIndex + 1 : 0,
                            total: searchFoundCount || 0,
                        },
                    }))),
                React.createElement(IconButton, { id: "btn-search-category-prev", className: "btn-embed", icon: "search-up", tooltip: t("Prev"), type: "button", disabled: !searchFoundCount, onClick: this.selectPrevMatch }),
                React.createElement(IconButton, { id: "btn-search-category-next", className: "btn-embed", icon: "search-down", tooltip: t("Next"), type: "button", disabled: !searchFoundCount, onClick: this.selectNextMatch })),
            React.createElement(SortableTree, { treeData: expandedTreeData, onChange: nop, onVisibilityToggle: this.toggleVisibility, canDrop: this.canDrop, onMoveNode: this.moveNode, style: { height: "95%" }, searchMethod: this.searchMethod, searchQuery: searchString, searchFocusOffset: searchFocusIndex, searchFinishCallback: this.searchFinishCallback, getNodeKey: this.getNodeKey, generateNodeProps: this.generateNodeProps })));
    }
    // tslint:disable-next-line:no-shadowed-variable
    searchMethod = ({ node, path, treeIndex, searchQuery, }) => {
        return (searchQuery.length > 0 &&
            node.title.toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1);
    };
    updateExpandedTreeData = (categories) => {
        const { expanded, showEmpty, treeData } = this.nextState;
        this.nextState.expandedTreeData = this.applyExpand(treeData, showEmpty, new Set(expanded), categories);
    };
    getNonEmptyCategories(treeData, ancestry) {
        let res = [];
        treeData.forEach((category) => {
            if (category.modCount > 0) {
                res.push(category.categoryId);
                res = res.concat(ancestry);
            }
            res = res.concat(this.getNonEmptyCategories(category.children, [].concat(ancestry, [category.categoryId])));
        });
        return res;
    }
    applyExpand(treeData, showEmpty, expanded, categories) {
        const filtered = new Set(showEmpty
            ? Object.keys(categories)
            : this.getNonEmptyCategories(treeData, []));
        return treeData
            .map((obj) => {
            if (!filtered.has(obj.categoryId)) {
                return undefined;
            }
            const copy = { ...obj };
            copy.expanded = expanded.has(copy.categoryId);
            copy.children = this.applyExpand(copy.children, showEmpty, expanded, categories);
            return copy;
        })
            .filter((obj) => obj !== undefined);
    }
    toggleShowEmpty = () => {
        const { t, categories, mods, onShowError } = this.props;
        const { showEmpty } = this.state;
        try {
            const newTree = createTreeDataObject(t, categories, mods);
            this.nextState.treeData = newTree;
            this.nextState.showEmpty = !showEmpty;
            this.updateExpandedTreeData(categories);
        }
        catch (err) {
            onShowError("An error occurred hiding/showing the empty categories", unknownToError(err), { allowReport: false });
        }
    };
    sortAlphabetically = () => {
        const { t, gameMode, categories, mods, onShowError, onSetCategoryOrder } = this.props;
        try {
            const newTree = createTreeDataObject(t, categories, mods, (a, b) => categories[a].name.localeCompare(categories[b].name));
            const newOrder = (base) => {
                return [].concat(...base.map((node) => [node.categoryId, ...newOrder(node.children)]));
            };
            onSetCategoryOrder(gameMode, newOrder(newTree));
        }
        catch (err) {
            onShowError("Failed to sort categories", unknownToError(err), {
                allowReport: false,
            });
        }
    };
    expandAll = () => {
        const { categories } = this.props;
        this.nextState.expanded = Object.keys(categories);
        this.updateExpandedTreeData(categories);
    };
    collapseAll = () => {
        this.nextState.expanded = [];
        this.updateExpandedTreeData(this.props.categories);
    };
    renameCategory = (categoryId) => {
        const { categories, gameMode, onShowDialog, onRenameCategory } = this.props;
        const category = categories[categoryId];
        // one user seems to have managed to get this called on a category that (no longer?)
        // exists
        if (category === undefined) {
            return;
        }
        onShowDialog("info", "Rename Category", {
            input: [{ id: "newCategory", value: category.name, label: "Category" }],
            condition: this.validateCategoryDialog,
        }, [{ label: "Cancel" }, { label: "Rename" }]).then((result) => {
            if (result.action === "Rename") {
                onRenameCategory(gameMode, categoryId, result.input.newCategory);
            }
        });
    };
    addCategory = (parentId) => {
        const { categories, gameMode, onSetCategory, onShowDialog } = this.props;
        const lastIndex = this.searchLastRootId(categories);
        if (Array.isArray(parentId)) {
            parentId = parentId[0];
        }
        onShowDialog("question", "Add Child Category", {
            input: [
                { id: "newCategory", value: "", label: "Category Name" },
                {
                    id: "newCategoryId",
                    value: lastIndex.toString(),
                    label: "Category ID",
                },
            ],
            condition: this.validateCategoryDialog,
        }, [{ label: "Cancel" }, { label: "Add" }]).then((result) => {
            if (result.action === "Add") {
                onSetCategory(gameMode, result.input.newCategoryId, {
                    name: result.input.newCategory,
                    parentCategory: parentId,
                    order: 0,
                });
            }
        });
    };
    hasEmptyInput = (input) => {
        const { t } = this.props;
        return input.value === ""
            ? {
                id: input.id,
                actions: ["Add", "Rename"],
                errorText: t("{{label}} cannot be empty.", {
                    replace: { label: input.label ? input.label : "Field" },
                }),
            }
            : undefined;
    };
    idExists = (input) => {
        const { t, categories } = this.props;
        return categories[input.value] !== undefined
            ? { id: input.id, actions: ["Add"], errorText: t("ID already used.") }
            : undefined;
    };
    validateCategoryDialog = (content) => {
        const results = [];
        content.input.forEach((inp) => {
            results.push(this.hasEmptyInput(inp));
            if (inp.id === "newCategoryId") {
                results.push(this.idExists(inp));
            }
        });
        return results.filter((res) => res !== undefined);
    };
    addRootCategory = () => {
        const { categories, gameMode, onSetCategory, onShowDialog, onShowError } = this.props;
        const lastIndex = this.searchLastRootId(categories);
        onShowDialog("question", "Add new Root Category", {
            input: [
                { id: "newCategory", value: "", label: "Category Name" },
                {
                    id: "newCategoryId",
                    value: lastIndex.toString(),
                    label: "Category ID",
                },
            ],
            condition: this.validateCategoryDialog,
        }, [{ label: "Cancel" }, { label: "Add", default: true }]).then((result) => {
            if (result.action === "Add") {
                onSetCategory(gameMode, result.input.newCategoryId, {
                    name: result.input.newCategory,
                    parentCategory: undefined,
                    order: 0,
                });
            }
        });
    };
    searchLastRootId(categories) {
        let maxId = 1000;
        if (categories !== undefined) {
            Object.keys(categories).filter((id) => {
                if (parseInt(id, 10) > maxId) {
                    maxId = parseInt(id, 10);
                }
            });
        }
        return maxId + 1;
    }
    selectPrevMatch = () => {
        const { searchFocusIndex, searchFoundCount } = this.state;
        this.nextState.searchFocusIndex =
            (searchFoundCount + searchFocusIndex - 1) % searchFoundCount;
    };
    selectNextMatch = () => {
        const { searchFocusIndex, searchFoundCount } = this.state;
        this.nextState.searchFocusIndex = (searchFocusIndex + 1) % searchFoundCount;
    };
    refreshTree(props) {
        const { t } = this.props;
        const { categories, mods } = props;
        if (categories !== undefined) {
            if (Object.keys(categories).length !== 0) {
                this.nextState.treeData = createTreeDataObject(t, categories, mods);
                this.updateExpandedTreeData(categories);
            }
        }
    }
    startSearch = (event) => {
        this.nextState.searchString = event.target.value;
    };
    searchFinishCallback = (matches) => {
        const { searchFocusIndex } = this.state;
        // important: Avoid updating the state if the values haven't changed because
        //  changing the state causes a re-render and a re-render causes the tree to search
        //  again (why?) which causes a new finish callback -> infinite loop
        if (this.state.searchFoundCount !== matches.length) {
            this.nextState.searchFoundCount = matches.length;
        }
        const newFocusIndex = matches.length > 0 ? searchFocusIndex % matches.length : 0;
        if (this.state.searchFocusIndex !== newFocusIndex) {
            this.nextState.searchFocusIndex = newFocusIndex;
        }
    };
    removeCategory = (id) => {
        const { categories, gameMode, onRemoveCategory } = this.props;
        let userConfirmed = false;
        id = Array.isArray(id) ? id[0] : id;
        const catKeys = Object.keys(categories);
        const childrenIds = catKeys.filter((key) => categories[key].parentCategory === id);
        const removeCat = () => {
            childrenIds.forEach((iterId) => this.removeCategory(iterId));
            onRemoveCategory(gameMode, id);
        };
        if (userConfirmed) {
            removeCat();
        }
        if (childrenIds.length > 0) {
            this.context.api
                .showDialog("question", "Remove Category", {
                text: "You're attempting to remove a category with one or more nested categories " +
                    "Which may in turn, also contain their own sub-categories. Are you sure you wish to proceed ?",
            }, [{ label: "Cancel", default: true }, { label: "Remove Category" }])
                .then((res) => {
                if (res.action !== "Cancel") {
                    userConfirmed = true;
                    removeCat();
                }
            });
        }
        else {
            onRemoveCategory(gameMode, id);
        }
    };
    generateNodeProps = (rowInfo) => {
        const { t } = this.props;
        const actions = [
            {
                icon: "edit",
                title: "Rename",
                action: this.renameCategory,
            },
            {
                icon: "folder-add",
                title: "Add Child",
                action: this.addCategory,
            },
            {
                icon: "remove",
                title: "Remove",
                action: this.removeCategory,
            },
        ];
        return {
            buttons: [
                React.createElement(ActionDropdown, { className: "category-buttons", group: "category-icons", staticElements: actions, t: t, instanceId: rowInfo.node.categoryId }),
            ],
        };
    };
    getNodeKey = (args) => {
        return args.node.categoryId;
    };
    toggleVisibility = (args) => {
        if (args.expanded) {
            this.nextState.expanded.push(args.node.categoryId);
        }
        else {
            this.nextState.expanded.splice(this.nextState.expanded.indexOf(args.node.categoryId));
        }
        this.updateExpandedTreeData(this.props.categories);
    };
    canDrop = (data) => {
        const { nextPath, node } = data;
        return !(nextPath ?? []).slice(0, -1).includes(node["categoryId"]);
    };
    moveNode = (data) => {
        const { gameMode, onSetCategory, onSetCategoryOrder } = this.props;
        const { path, node, treeData } = data;
        if (path[path.length - 2] !== node["parentId"]) {
            onSetCategory(gameMode, node["categoryId"], {
                name: node.title,
                order: node["order"],
                parentCategory: path[path.length - 2],
            });
        }
        else {
            const newOrder = (base) => {
                return [].concat(...base.map((node) => [node.categoryId, ...newOrder(node.children)]));
            };
            onSetCategoryOrder(gameMode, newOrder(treeData));
        }
    };
}
const emptyObj = {};
function mapStateToProps(state) {
    const gameMode = activeGameId(state);
    return {
        gameMode,
        language: state.settings.interface.language,
        categories: state.persistent.categories[gameMode] || emptyObj,
        mods: state.persistent.mods[gameMode],
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onRenameCategory: (gameId, categoryId, newCategory) => dispatch(renameCategory(gameId, categoryId, newCategory)),
        onSetCategory: (gameId, categoryId, category) => dispatch(setCategory(gameId, categoryId, category)),
        onRemoveCategory: (gameId, categoryId) => dispatch(removeCategory(gameId, categoryId)),
        onSetCategoryOrder: (gameId, categoryIds) => dispatch(setCategoryOrder(gameId, categoryIds)),
        onShowError: (message, details, options) => showError(dispatch, message, details, options),
        onShowDialog: (type, title, content, actions) => dispatch(showDialog(type, title, content, actions)),
    };
}
export default translate(["common"])(connect(mapStateToProps, mapDispatchToProps)(CategoryList));
